__turbopack_context__.v({
  "content-marquee": "ContentMarquee-module-scss-module__907sdG__content-marquee",
  "content_marquee": "ContentMarquee-module-scss-module__907sdG__content_marquee",
  "content_marquee_group": "ContentMarquee-module-scss-module__907sdG__content_marquee_group",
  "content_marquee_item": "ContentMarquee-module-scss-module__907sdG__content_marquee_item",
  "content_marquee_track": "ContentMarquee-module-scss-module__907sdG__content_marquee_track",
});
